import React, { useContext } from "react"; 
import { NavLink, useLocation  } from 'react-router-dom';
import AuthContext from '../../context/AuthContext'
import { menuItems } from '../../mock/menu'
const Navbar = () => { 
   
    const location = useLocation(); 
    const { pathname } = location; 
    const splitLocation = pathname.split("/");  
     
    let { user } = useContext(AuthContext)
    let userRoles = user.roles  
     
    const navMenu = menuItems.filter(({disabled}) => !userRoles.includes(disabled));
  
    return (
      <>  
      <nav className="pcoded-navbar menupos-fixed menu-dark menu-item-icon-style6">
        <div className="navbar-wrapper ">
          <div className="navbar-brand header-logo">
            <a href="#" className="b-brand"> 
              <span className="b-title"> </span>  
            </a>
            <a className="mobile-menu" id="mobile-collapse"><span /></a>
          </div>
          <div className="navbar-content scroll-div">
            <ul className="nav pcoded-inner-navbar "> 
              {navMenu.map(item => ( 
                item.type === 'link'
                ? 
                !item.disabled && 
                  <li key={item.id} className={splitLocation[1] === item.url.replace('/', '') ? "nav-item active" : "nav-item"}  >  
                    <NavLink to={item.url}>
                      <span className="pcoded-micon"><i className={item.icon}></i></span>
                      <span className="pcoded-mtext">{item.name}</span> 
                    </NavLink>
                  </li>
                :
                  !item.disabled && <li key={item.id} className="nav-item pcoded-menu-caption"> <label>{item.name}</label></li> 
                )
              )} 
            </ul> 
            <div className="ps__rail-x" style={{left: '0px', bottom: '0px'}}><div className="ps__thumb-x" tabIndex={0} style={{left: '0px', width: '0px'}} /></div><div className="ps__rail-y" style={{top: '0px', right: '0px'}}><div className="ps__thumb-y" tabIndex={0} style={{top: '0px', height: '0px'}} />jj</div></div> 
        </div>
      </nav>
      </>
    )

}
export default Navbar 